import { InputGroupText } from 'Component/core/elements/InputGroup'
import styled from 'styled-components'

export const TokenText = styled(InputGroupText)`
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  text-transform: uppercase;
`